import { render, staticRenderFns } from "./OutboxList.vue?vue&type=template&id=133b07dc&scoped=true&"
import script from "./OutboxList.vue?vue&type=script&lang=js&"
export * from "./OutboxList.vue?vue&type=script&lang=js&"
import style0 from "./OutboxList.vue?vue&type=style&index=0&id=133b07dc&lang=scss&scoped=true&"
import style1 from "./OutboxList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b07dc",
  null
  
)

export default component.exports